var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHotJobStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20499_68747)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29421 0L11.797 12.6214L1.15625 4.44873L7.29421 0Z",
    fill: "url(#paint0_radial_20499_68747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.301 0L11.7969 12.6214L22.4376 4.44873L16.301 0Z",
    fill: "url(#paint1_radial_20499_68747)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2206 13.2557L11.7969 12.8828L22.8774 20.4533L25.2206 13.2557Z",
    fill: "url(#paint2_radial_20499_68747)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.62695 12.994L11.7968 12.6211L0.717544 20.1916L-1.62695 12.994Z",
    fill: "url(#paint3_radial_20499_68747)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5602 26.4399L11.7681 13.5879L7.97461 26.4399H15.5602Z",
    fill: "url(#paint4_radial_20499_68747)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7145 9.1592C20.815 10.0342 20.0608 11.0238 19.4625 12.0899C19.2261 12.5116 19.0134 12.9464 18.8272 13.3905C17.8907 15.6175 17.5869 18.0962 18.0069 20.5446C16.1287 19.5589 14.0682 19.0674 12.0077 19.0674C9.94714 19.0674 7.88531 19.5602 6.00707 20.5446C6.13123 19.8198 6.19331 19.0924 6.19331 18.369C6.19331 17.3807 6.07839 16.4016 5.85649 15.4488C5.3057 13.0901 4.0892 10.8986 2.30078 9.15789C6.49974 8.54908 10.1307 5.91754 12.009 2.12109C13.8872 5.91754 17.5182 8.54908 21.7172 9.15789L21.7145 9.1592Z",
    fill: "#FFCB00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0818 6.76172C13.1081 8.83454 15.0907 10.2722 17.3837 10.6043C15.7247 12.2185 14.9665 14.543 15.3588 16.8228C13.3075 15.7475 10.8574 15.7475 8.8061 16.8228C9.19839 14.5444 8.44023 12.2185 6.78125 10.6043C9.07423 10.2722 11.0568 8.83454 12.0831 6.76172H12.0818Z",
    fill: "#FFA800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0051 2.12305C11.9945 2.19025 11.3077 6.46108 8.85222 7.99626C6.39149 9.5354 2.34178 9.16379 2.29688 9.15984C6.49584 8.55104 10.1268 5.91949 12.0051 2.12305Z",
    fill: "#FFA800"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00511 20.5455C6.12927 19.8208 6.19135 19.0934 6.19135 18.3699C6.19135 14.9319 4.80843 11.6019 2.29883 9.16016C2.35827 9.19442 6.20456 11.3687 7.09481 14.4285C7.98638 17.4936 6.03153 20.506 6.00644 20.5455H6.00511Z",
    fill: "#FFA800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0038 20.5441C16.1255 19.5584 14.065 19.0669 12.0045 19.0669C9.94398 19.0669 7.88215 19.5598 6.00391 20.5441C6.03296 20.5059 8.11726 17.8111 11.9794 17.844C15.8693 17.877 18.0038 20.5441 18.0038 20.5441Z",
    fill: "#FFA800"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7141 9.15789C11.9398 9.768 12.0059 2.12109 12.0059 2.12109C13.8841 5.91754 17.5151 8.54908 21.7141 9.15789Z",
    fill: "#FFA800"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7112 9.15952C20.4564 10.3798 19.483 11.824 18.8239 13.3908C17.8874 15.6178 17.5836 18.0965 18.0036 20.5449C17.9864 20.5146 16.7515 18.0174 17.2798 14.5188C17.8068 11.0255 21.6491 9.19115 21.7112 9.1582V9.15952Z",
    fill: "#FFA800"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0815 10.0273C12.5187 10.9102 13.3628 11.5217 14.3389 11.664C13.6322 12.3505 13.3099 13.3415 13.4764 14.3114C12.6033 13.8528 11.5598 13.8528 10.6867 14.3114C10.8532 13.3415 10.5309 12.3505 9.82422 11.664C10.8003 11.523 11.6443 10.9102 12.0815 10.0273Z",
    fill: "#FFA800"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M18.8261 13.3905C17.8897 15.6175 17.5859 18.0962 18.0059 20.5446C16.1277 19.5589 14.0672 19.0674 12.0066 19.0674C9.94612 19.0674 7.88428 19.5603 6.00604 20.5446C6.1302 19.8198 6.19228 19.0925 6.19228 18.369C6.19228 17.3807 6.07737 16.4016 5.85547 15.4489C6.06548 15.4344 6.27418 15.4067 6.48023 15.3698C7.69408 15.1511 8.82076 14.5989 9.89329 13.9901C10.9645 13.3813 12.004 12.7066 13.132 12.2085C14.6602 11.5351 16.3839 11.2018 18.0152 11.5549C18.5171 11.663 19.0071 11.8448 19.4615 12.0886C19.225 12.5103 19.0124 12.9451 18.8261 13.3892V13.3905Z",
    fill: "url(#paint5_radial_20499_68747)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57856 16.2852L4.75952 16.9585L5.43447 17.1391L4.75952 17.3209L4.57856 17.993L4.39761 17.3209L3.72266 17.1391L4.39761 16.9585L4.57856 16.2852Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0743 14.9219L20.2896 15.7178L21.086 15.9313L20.2896 16.1461L20.0743 16.9407L19.8603 16.1461L19.0625 15.9313L19.8603 15.7178L20.0743 14.9219Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3536 3.83398L15.5675 4.62859L16.3653 4.84338L15.5675 5.05686L15.3536 5.85278L15.1383 5.05686L14.3418 4.84338L15.1383 4.62859L15.3536 3.83398Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.436 19.5117L13.6289 20.2233L14.3421 20.4144L13.6289 20.6055L13.436 21.317L13.2445 20.6055L12.5312 20.4144L13.2445 20.2233L13.436 19.5117Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27848 6.01562L5.41321 6.50978L5.90852 6.64419L5.41321 6.77729L5.27848 7.27276L5.14507 6.77729L4.64844 6.64419L5.14507 6.50978L5.27848 6.01562Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8117 6.17188L17.9451 6.66735L18.4417 6.80044L17.9451 6.93354L17.8117 7.42901L17.6783 6.93354L17.1816 6.80044L17.6783 6.66735L17.8117 6.17188Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4269 19.7051L10.5616 20.2006L11.0583 20.3336L10.5616 20.4667L10.4269 20.9622L10.2935 20.4667L9.79688 20.3336L10.2935 20.2006L10.4269 19.7051Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52416 4.5625L7.78701 5.53895L8.76576 5.8025L7.78701 6.06605L7.52416 7.04251L7.25999 6.06605L6.28125 5.8025L7.25999 5.53895L7.52416 4.5625Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72579 13.3398L2.99656 14.3413L4.0004 14.6115L2.99656 14.8803L2.72579 15.8818L2.45501 14.8803L1.45117 14.6115L2.45501 14.3413L2.72579 13.3398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20499_68747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5262 12.5077) rotate(-35.9362) scale(10.12 10.1127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20499_68747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0721 12.4868) rotate(-144.064) scale(10.12 10.1127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20499_68747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9611 13.0773) rotate(-71.9605) scale(10.1068 10.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20499_68747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5889 12.7803) rotate(-108.04) scale(10.1068 10.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_20499_68747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6307 13.8383) scale(10.1282 10.1045)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20499_68747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4293 9.13684) scale(17.8472 17.8055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20499_68747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHotJobStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hot-job-star.333779c8.svg";
export { ForwardRef as ReactComponent };